<template>
  <section>
    <h3 class="title-small">Ontwerpen</h3>
    <ul>
      <li v-for="(product, index) in products" :key="index" class="product">
        <span class="quantity">{{ product.quantity }} x</span>
        <div
          class="img-holder"
          :style="{
            'background-image': `url(${setImg(
              product.previewImage,
              product.printStoreId
            )})`
          }"
        ></div>
        <section class="text-holder">
          <div class="title">
            {{ product.name }}
          </div>

          <ul class="specs">
            <template
              v-for="(value, key) in product.printSpecification"
              :key="key"
            >
              <li v-if="key !== 'productcode'">{{ key }} : {{ value }}</li>
            </template>
          </ul>
        </section>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  props: ['products'],
  methods: {
    setImg(img, id) {
      return `/media/print-store/${id}/preview/${img}/282`
      /*  if (img.indexOf('http') === 0) {
        return img
      } else {
        return '/images/package-default.jpg'
      } */
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
  display: flex;
  padding: 10px 0px;
  align-items: center;
}

.quantity {
  margin-right: 12px;
  flex-shrink: 0;
  flex-grow: 0;
  min-width: 24px;
  font-weight: 600;
}

.img-holder {
  width: 39px;
  height: 39px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 15px;
  flex-shrink: 0;
  flex-grow: 0;
}

.text-holder {
  line-height: 19px;
  flex-grow: 1;
}

.title {
  font-weight: 600;
  span {
    font-weight: 300;
  }
}

.specs {
  font-weight: 300;
}

.spec-title {
  font-weight: 300;
}
</style>
